<span class="font-16">
  Transparency:
  {{
    windowsWithoutOpacity.includes(
      stateManagerProjectService.currentSelectedWindow
    )
      ? minOpacity
      : stateManagerProjectService.isActiveShowChangesMode === false
      ? maxOpacity - cornerstoneService.getMaskOpacityValue()
      : maxOpacity / 2
  }}%
</span>
<!-- TODO: The 'tickInterval' property no longer exists -->
<mat-slider
  step="1"
  min="0"
  max="100"
  [disabled]="(isDisabled() | async)!"
  [ngClass]="{ disabled: (isDisabled() | async)! }"
 #ngSlider><input [(ngModel)]="opacityMaskNumber" matSliderThumb (input)="changeMaskOpacity({source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value})" #ngSliderThumb="matSliderThumb" />
</mat-slider>
